import { render, staticRenderFns } from "./ButtonPrimary.vue?vue&type=template&id=103bdf7a&scoped=true"
import script from "./ButtonPrimary.vue?vue&type=script&lang=ts"
export * from "./ButtonPrimary.vue?vue&type=script&lang=ts"
import style0 from "./ButtonPrimary.vue?vue&type=style&index=0&id=103bdf7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103bdf7a",
  null
  
)

export default component.exports